module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_7.ec566c6f.png";